import RuleProvider from 'diagram-js/lib/features/rules/RuleProvider';
import inherits from 'inherits';

/**
 * @param {import("diagram-js/lib/core/EventBus").default<null>} eventBus
 * @param {boolean} gatewayResizingEnabled
 */
export function ResizeGateway(eventBus, gatewayResizingEnabled) {
    // @ts-expect-error
    RuleProvider.call(this, eventBus);
    this.gatewayResizingEnabled = gatewayResizingEnabled || false;
}

inherits(ResizeGateway, RuleProvider);

ResizeGateway.$inject = ['eventBus', 'config.gatewayResizingEnabled'];

ResizeGateway.prototype.init = function () {
    const me = this;

    // @ts-expect-error
    me.addRule('shape.resize', 1500, function (/** @type {{ shape: { businessObject: { $instanceOf: (arg0: string) => any; }; }; newBounds: { width: number; height: number; }; }} */ data) {
        if (me.gatewayResizingEnabled && data.shape.businessObject &&
            (data.shape.businessObject.$instanceOf('bpmn:Gateway') ||
                data.shape.businessObject.$instanceOf('bpmn:ExclusiveGateway'))) {
            if (data.newBounds) {
                data.newBounds.width = Math.max(47, data.newBounds.width);
                data.newBounds.height = Math.max(47, data.newBounds.height);
            } return true;
        }
    });
};